import styled, { css } from 'styled-components';
import { DropDownProps, ListWrapperProps } from '@types';
import { ListItem } from '../../App.styled';

export const ListWrapper = styled.div<ListWrapperProps>`
    background-color: ${({ theme }) => theme?.colors?.white};
    position: absolute;
    border: 1px solid rgba(214, 224, 236, 0.6);
    border-radius: 0.25rem;
    box-shadow: 1px 1px 4px 2px rgba(142, 152, 162, 0.1);
    box-sizing: border-box;
    min-width: 12.813rem;
    z-index: 1000;
`;

const disabled = () => css`
    opacity: 0.5;
    pointer-events: none;
`;

const onSelection = () => css`
    background-color: ${({ theme: { colors } }) => colors.cyanBlueLight};
    a {
        color: ${({ theme: { colors } }) => colors.white};
    }
`;

export const ListItems = styled(ListItem)<DropDownProps>`
    font-size: ${props => props.fontSize};
    color: ${props => props.fontColor};
    padding: 11px 18px;
    font-weight: ${({ theme }) => theme.font.weights.Regular};
    cursor: pointer;
    text-align: center;
    white-space: nowrap;
    letter-spacing: 0.1px;
    line-height: 1.188rem;
    ${props => props.disabled && disabled()}
    ${({ isSelected }) => isSelected && onSelection()}
`;

export const Hr = styled.hr`
    margin: 0;
    color: ${({ theme }) => theme.colors.black};
    &:last-child {
        display: none;
    }
`;

export const DropDownText = styled(ListItems)`
    padding: 0 0 1rem 0;
`;
